exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submission-full .actions a{font-size:13px;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#4c4b4b;cursor:pointer}.submission-full .actions i{color:#657786;font-size:17px;margin-left:1em}.submission-full .actions .count{margin-left:.5em}.post-block{overflow:auto;background:#fff}.vote-area{background-color:#fff}.remove-reason{margin-top:10px;margin-left:20px;text-align:left}.remove-reason textarea{border-radius:5px;margin-top:5px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64818428","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/FullSubmission.vue
// module id = Xphy
// module chunks = 0